var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('relation-data',{attrs:{"value":_vm.currentRelation,"type":_vm.currentType,"link":true}})}
var staticRenderFns = []

export { render, staticRenderFns }